export function FourthSection(props: Array<{
    quotation: string
    author: Array<{
        authorName: string
    }>
}>) {
    const { quotation, author } = props[0]
    return (
        <div className="landing-fourth-section">
            <div className="quotation" dangerouslySetInnerHTML={{ __html: quotation }} />
            <div className="author-wrapper">
                {author.map((item, index) => (
                    <div key={index} className="author-name" dangerouslySetInnerHTML={{ __html: item.authorName.replaceAll('\n','<br/>') }} />
                ))}
            </div>
        </div>
    );
}